
import { BehaviorSubject, Subject } from 'rxjs';

export class ParametrizacaoSharedDataService {

  private updateList = new Subject<boolean>();
  updateList$ = this.updateList.asObservable();

  private dominioSelecionado = new BehaviorSubject<any>(null);
  dominioSelecionado$ = this.dominioSelecionado.asObservable();

  constructor() { }

  public setUpdateList(data: boolean): void {
    this.updateList.next(data);
  }

  public setDominioSelecionado(data: any): void {
    this.dominioSelecionado.next(data);
  }
}
